/** RevenueIntelligenceRoute — skin-aware switcher for /revenue-intelligence. */
import { useUISkin } from "@/data/UISkinContext";
import RevenueIntelligence from "./RevenueIntelligence";
import RevenueIntelligenceCockpit from "./RevenueIntelligenceCockpit";

export default function RevenueIntelligenceRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <RevenueIntelligenceCockpit />;
  return <RevenueIntelligence />;
}
